import { openCookiePreferences } from '@/lib/consent';

const CookiePolicy = () => {
  const updated = 'February 2026';
  return (
    <div className="max-w-4xl mx-auto px-6 py-16 text-gray-800" data-testid="cookie-policy-page">
      <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-3">Cookie Policy</h1>
      <p className="text-sm text-gray-500 mb-10">Last updated: {updated}</p>

      <div className="space-y-8 leading-relaxed">
        <section>
          <p>
            This Cookie Policy explains how GN Management Inc. uses cookies and similar technologies on gnmgt.com. It should be read alongside
            our Privacy Policy.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-gray-900 mb-2">What Are Cookies?</h2>
          <p className="text-sm">
            Cookies are small text files placed on your device by websites you visit. They are widely used to make sites work, or work more
            efficiently, and to provide information to the site owners.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-gray-900 mb-2">Categories We Use</h2>
          <div className="mt-4 space-y-4">
            <div className="p-4 border border-gray-200 rounded-md">
              <h3 className="font-semibold text-sm text-gray-900">Strictly Necessary</h3>
              <p className="text-xs text-gray-600 mt-1">
                Required for the Site to function — routing, session, admin authentication, and security. These cannot be disabled.
              </p>
            </div>
            <div className="p-4 border border-gray-200 rounded-md">
              <h3 className="font-semibold text-sm text-gray-900">Analytics (Optional)</h3>
              <p className="text-xs text-gray-600 mt-1">
                Google Analytics 4 (measurement ID G-5ZWEQD4XBE) and PostHog help us understand how visitors use the Site so we can improve it.
                No analytics cookies are set unless you consent.
              </p>
            </div>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-bold text-gray-900 mb-2">Managing Your Preferences</h2>
          <p className="text-sm">You can change your consent at any time.</p>
          <button
            onClick={openCookiePreferences}
            className="mt-3 px-5 py-2.5 bg-[#20B2AA] hover:bg-[#1a938c] text-white text-sm font-semibold rounded-md transition-colors"
            data-testid="cookie-policy-open-prefs"
          >
            Manage Cookie Preferences
          </button>
          <p className="text-xs text-gray-500 mt-3">
            You can also block or delete cookies through your browser settings. Doing so may affect Site functionality.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-gray-900 mb-2">Contact</h2>
          <p className="text-sm">
            Questions? Email{' '}
            <a href="mailto:inquiry@gnmgt.com" className="text-[#20B2AA] hover:underline">inquiry@gnmgt.com</a>.
          </p>
        </section>
      </div>
    </div>
  );
};

export default CookiePolicy;
